module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"audioNotPlayable":"Diese Aufnahme kann im Moment nicht auf Deinem Gerät abgespielt werden.","audioConverting":"Die Aufnahme wird gerade noch vorbereitet und steht dir bald zur Verfügung."},"en":{"audioNotPlayable":"This audio is currently not playable on your device.","audioConverting":"This audio is currently converting."}}')
  delete Component.options._Ctor
}
